// extracted by mini-css-extract-plugin
export default {"container":"QL-z","topReviewHeading":"RL-z","criticalReview":"SL-z","favorableReview":"TL-z","vsSeparator":"UL-z"};